import { signInResetPasswordFormStyles } from "@insite/content-library/Widgets/SignIn/SignInResetPasswordForm";
import { css } from "styled-components";

signInResetPasswordFormStyles.cancelButton = {
    variant: "tertiary",
    css: css`
        margin-right: 10px;
    `,
};
